'use strict';
/*
 [
    {
        "bePaymentTypeId": 750700,
        "paymentTypeId": 0,
        "paymentTypeDescription": "Visa",
        "paymentName": "asdf",
        "paymentNumber": "XXXXXXXXXXXX1111",
        "paymentSecurityNumber": "",
        "expMonth": "01",
        "expYear": "19",
        "paymentPostalCode": "9999"
    }
 ]
 */
import angular from 'angular';
import {UserService} from '@nuskin/ns-account';
import {events, RunConfigService, UrlService} from '@nuskin/ns-util';
import {getCachedConfigField} from '@nuskin/configuration-sdk';

import {shopModule} from '../module.js';
import {Payment, ShopServiceApiVersion} from '@nuskin/ns-shop';

shopModule.factory('nsPayment', ['$resource','nsUtil', function($resource, nsUtil) {
    let headers = {
        'client_id': RunConfigService.getRunConfig().clientId,
        'client_secret': RunConfigService.getRunConfig().clientSecret
    };
    let transform = function(data) {
        let object={};
        if (!nsUtil.isEmpty(data.getBePaymentTypeId())) {
            object.bePaymentTypeId = data.getBePaymentTypeId();
        }
        if (!nsUtil.isEmpty(data.getPaymentTypeId())) {
            object.paymentTypeId=data.getPaymentTypeId();
        }
        if (!nsUtil.isEmpty(data.getPaymentTypeDescription())) {
            object.paymentTypeDescription=data.getPaymentTypeDescription();
        }
        if (!nsUtil.isEmpty(data.getPaymentName())) {
            object.paymentName=data.getPaymentName();
        }
        if (!nsUtil.isEmpty(data.getPaymentNumber())) {
            object.paymentNumber=data.getPaymentNumber();
        }
        if (!nsUtil.isEmpty(data.getPaymentSecurityNumber())) {
            object.paymentSecurityNumber=data.getPaymentSecurityNumber();
        }
        if (!nsUtil.isEmpty(data.getExpMonth())) {
            object.expMonth=data.getExpMonth();
        }
        if (!nsUtil.isEmpty(data.getExpYear())) {
            object.expYear=data.getExpYear();
        }
        if (!nsUtil.isEmpty(data.getPaymentPostalCode())) {
            object.paymentPostalCode=data.getPaymentPostalCode();
        }
        if (!nsUtil.isEmpty(data.getAddress1())) {
            object.address1=data.getAddress1();
        }
        if (!nsUtil.isEmpty(data.getAddress2())) {
            object.address2=data.getAddress2();
        }
        if (!nsUtil.isEmpty(data.getCity())) {
            object.city=data.getCity();
        }
        if (!nsUtil.isEmpty(data.getRegion())) {
            object.region=data.getRegion();
        }
        if (!nsUtil.isEmpty(data.getEmail())) {
            object.email = data.getEmail();
        }
        if (!nsUtil.isEmpty(data.getPhone())) {
            object.phone = data.getPhone();
        }
        if (!nsUtil.isEmpty(data.getCountryCode())) {
            object.countryCode = data.getCountryCode();
        }
        if (!nsUtil.isEmpty(data.getDefaultPayment())) {
            object.defaultPayment=data.getDefaultPayment();
        }
        if (!nsUtil.isEmpty(data.getMandateType())) {
            object.mandateType=data.getMandateType();
        }
        if (!nsUtil.isEmpty(data.getStoredCredentialsAgreementDate())) {
            object.storedCredentialsAgreementDate = data.getStoredCredentialsAgreementDate();
        }
        return object;
    };

    let paymentServiceUrl = function() {
        return `${UrlService.getAwsUrl().awsUrl}/paymentprofile/v1/:sapId`;
    }();

    let getHeaders = function() {
        let user = UserService.getUser();
        if (user) {
            headers.Authorization = `JWT ${user.eid}`;
        }
    };

    let transformPaymentQueryResponse = function (data) {
        let paymentList = [];

        try {
            let payments = (JSON.parse(data)).PaymentList;

            // Dimension measured: Whether the user has any saved payment methods or not.
            events.publish(events.shop.TAG_HAS_SAVED_PAYMENT, {
                hasSavedPayment: Boolean(payments && payments.length > 0)
            });

            angular.forEach(payments, function (payment) {
                // We will change it to match the one we have in the form
                payment["savePayment"] = true;
                let p = new Payment(payment);
                paymentList.push(p);
            });
        }
        catch (e) {
            console.log("Error - transformPaymentQueryResponse couldn't parse the payment");
            events.publishError(events.errors.PAYMENT);
        }

        return paymentList;
    };

    /**
     * Transforms response from Payment Service POST call
     * If sucessful returns a Payment Object otherwise returns messages in Error Response
     * @param {*} data
     */
    let transformPaymentResponse = function(data) {
        let payment = (JSON.parse(data)).Payment;
        if (payment !== undefined) {
            payment["savePayment"] = true;
            return new Payment(payment);
        }
        else {
            return JSON.parse(data).messages;
        }
    };

    let paymentRes = $resource(paymentServiceUrl, {}, {
        'update': {
            method: 'PUT',
            headers: headers,
            transformRequest: function (data) {
                return JSON.stringify(transform(data));
            },
            transformResponse: transformPaymentResponse
        },
        'save': {
            method: 'POST',
            headers: headers,
            transformRequest: function (data) {
                return JSON.stringify(transform(data));
            },
            transformResponse: transformPaymentResponse
        },
        'query': {
            method: 'GET',
            headers: headers,
            isArray: true,
            transformResponse: transformPaymentQueryResponse
        },
        'get': {
            method: 'GET',
            headers: headers,
            transformResponse: transformPaymentResponse
        },
        'remove': {
            method: 'DELETE',
            headers: headers
        }
    });

    getHeaders();

    // wrapper around the resource object so we can set the updated headers
    return {
        update: (params, object, success, failure) => {
            getHeaders();
            return paymentRes.update(params, object, success, failure);
        },
        save: (params, object, success, failure) => {
            getHeaders();
            return paymentRes.save(params,object, success,failure);
        },
        query: (params, success, failure) => {
            getHeaders();
            return paymentRes.query(params, success, failure);
        },
        get: (params, success, failure) => {
            getHeaders();
            return paymentRes.get(params, success, failure);
        },
        remove: (params, success, failure) => {
            getHeaders();
            return paymentRes.remove(params, success, failure);
        }
    };
}]);

/*
 [
 {
 "id": 0,
 "ofsId": "VISA",
 "blocked": false,
 "processorCode": null,
 "formName": "addPayment",
 "paymentClass": "CCARD",
 "ccImageUrl": null
 }
 ]
 */
shopModule.factory('nsPaymentTypesAllowed', ['$resource', function ($resource) {
    let eidObject = {};
    let user = UserService.getUser();
    if (user){
        eidObject = { eid: user.eid };
    }

    return $resource(ShopServiceApiVersion.getAvailablePaymentTypeServiceVersionedUrl(
        getCachedConfigField('availablePaymentTypeServiceUrl')
    ), {}, {
        'query': {
            method: 'GET',
            headers: {
                'client_id': RunConfigService.getRunConfig().clientId,
                'client_secret': RunConfigService.getRunConfig().clientSecret
            },
            data: eidObject,
            isArray: false
        }
    });
}]);
